import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'attributeValue',
    serviceName: 'shopadmin',
    query: gql`
      query attributeValue(
        $ids: [String]
        $title: String
        $code: String
        #$page: Int
        #$limit: Int
        $attribute_ids: [String]
        $attribute_category_ids: [String]
      ) {
        attributeValue(
          ids: $ids
          title: $title
          code: $code
          #page: $page
          #limit: $limit
          attribute_ids: $attribute_ids
          attribute_category_ids: $attribute_category_ids
        ) {
          total
          last_page
          data {
            id
            title
            media {
              full_url
            }
            attribute {
              title
              category {
                title
              }
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteAttributeValue',
    serviceName: 'admin',
    query: gql`
      mutation deleteAttributeValue($ids: [String]!) {
        deleteAttributeValue(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'attributeValue',
    serviceName: 'shopadmin',
    query: gql`
      query attributeValue($ids: [String]) {
        attributeValue(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'attributeValue',
    serviceName: 'shopadmin',
    query: gql`
      query attributeValue($ids: [String]) {
        attributeValue(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
